module.exports = __webpack_public_path__ + "static/media/NK-FB-2-avgust.647af0e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nutrikasa/NK-FB-2-avgust.jpg
// module id = 425
// module chunks = 0